import React from 'react';
import PropTypes from 'prop-types';
import { GlobalNavigation } from '../responsive/organisms/GlobalNavigation';
import { MainNavigation } from '../responsive/organisms/MainNavigation';
import { DrupalStaticBuildStatus } from './components/DrupalStaticBuildStatus';

export const Header = ({ content }) => (
  <>
    <GlobalNavigation />
    <MainNavigation content={content} />
    <DrupalStaticBuildStatus />
  </>
);

Header.defaultProps = {
  content: {}
};

Header.propTypes = {
  content: PropTypes.objectOf(PropTypes.any)
};
